import { SendDownloadLinksFormController } from '../controller/SendDownloadLinksFormController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PackageData, PackageLinksData } from '../../packagesGrid/types';
import { MonthlyProductType } from '../../../license/types/MonthlyProductType';

export class SendDownloadLinksFormWebComponent extends BaseWebComponentElement {
  private packageId: string;
  private packageProductType: MonthlyProductType;
  private packageLinks: PackageLinksData;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SendDownloadLinksFormController,
    });
  }

  public getPackageId(): string {
    return this.packageId;
  }

  public setPackageId(item: string): void {
    this.packageId = item;
  }

  public getPackageProductType(): MonthlyProductType {
    return this.packageProductType;
  }

  public setPackageProductType(item: MonthlyProductType): void {
    this.packageProductType = item;
  }

  public getPackageLinks(): PackageLinksData {
    return this.packageLinks;
  }

  public setPackageLinks(links: PackageLinksData): void {
    this.packageLinks = links;
  }
}
